import React from 'react';
import { IonBackButton, IonButtons, IonCard, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonSegment, IonSegmentButton, IonToast, IonToolbar, SegmentChangeEventDetail, withIonLifeCycle } from '@ionic/react';

//	L O C A L E

import { locale___App } from '../../../App.locale';
import { locale___SbDigitalMenuViewPage } from './sb-digitalmenu-view.locale';

//	S T Y L E

import './sb-digitalmenu-view.scss';

//	S T A T E   -   P R O P S

import { props___SbDigitalMenuViewPage, state___SbDigitalMenuViewPage, state___SbDigitalMenuViewPage___default } from './sb-digitalmenu-view.state';

//	T Y P E S

import { type___api___response } from '../../../types/types.api-response';

//	L I B S

import { lib_names_shared } from '../../../libs/lib.names.shared';

//	S E R V I C E S

import { service_RestApiService } from '../../../services/service-api';
import { service_Router } from '../../../services/service-router';
import { service_LocalizationService } from '../../../services/service-localization';

//	C O M P O N E N T S

import Com404Component from '../../../components/com-404/com-404';
import ComButtonGenericComponent from '../../../components/com-button-generic/com-button-generic';
import ComSpinnerInlineComponent from '../../../components/com-spinner-inline/com-spinner-inline';

//	M O D A L S

import MdDishEditModal from '../../../modals/md-dish-edit/md-dish-edit';

//	C L A S S

class SbDigitalMenuViewPage extends React.Component<props___SbDigitalMenuViewPage, state___SbDigitalMenuViewPage> {

//#region 																							D E C L A R A T I O N S

	private readonly _API: service_RestApiService = new service_RestApiService();
	private readonly _ROUTER: service_Router = new service_Router();
	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___SbDigitalMenuViewPage,
	) {
		super(props);
		this.state = state___SbDigitalMenuViewPage___default;
	}

//#endregion

//#region 																							R E A D   P R O P S

	private read_props___digitalmenu = async () => {
		const ___temp___poi___props: type___api___response = await this._API.digitalmenus___read_single(this.state.digitalmenu___id);
		if (!___temp___poi___props || ___temp___poi___props.response !== 'success' || ___temp___poi___props.data === null) { console.log('404'); }
		this.setState({
			digitalmenu___props: ___temp___poi___props.data,
			digitalmenu___props___isLoading: false,
		}, () => {
			this.handle___link___generate('link');
		});
	}

//#endregion

//#region 																							H A N D L E R S

	private handle___link___generate = (___target: state___SbDigitalMenuViewPage['digitalmenu___url__type']) => {
		this.setState({
			digitalmenu___url__type: ___target
		}, () => {
			this.setState({
				digitalmenu___url: (() => { switch (this.state.digitalmenu___url__type) {
					case 'link': return lib_names_shared.endpoints.sharing___view + this.state.digitalmenu___props['digitalmenu_vanity']; break;
					case 'qr': return lib_names_shared.endpoints.sharing___qr + this.state.digitalmenu___props['digitalmenu_vanity']; break;
					case 'key': return this.state.digitalmenu___props['digitalmenu_id']; break;
				}})(),
			});
		});
	}

	private handle___link___share = async () => {
		const ___link_to_share: string = this.state.digitalmenu___url.trim();
		await navigator.clipboard.writeText(___link_to_share);
		this.setState({
			ionToast___copied___isOpen: true,
		});
	}

//#endregion

//#region 																							L I F E C Y C L E

	ionViewDidEnter() : void {
		const ___digitalmenu_id: string | null = this._ROUTER.get_id(this.props);
		this.setState({
			digitalmenu___id: ___digitalmenu_id,
		}, async () => {
			await this.read_props___digitalmenu();
		});
	}

//#endregion

//#region 																							R E T U R N

	render() : React.ReactNode {
		return <>
			<IonPage>

				<MdDishEditModal isOpen={ this.state.ionModal___MdDishEditModal___isOpen } dish_digitalmenu={ this.state.digitalmenu___id } dish_id={ this.state.ionModal___MdDishEditModal___target_id } dish_category={ this.state.ionModal___MdDishEditModal___target_category } event___onDidDismiss={() => { this.setState({ ionModal___MdDishEditModal___isOpen: false, ionModal___MdDishEditModal___target_id: null, ionModal___MdDishEditModal___target_category: null }, () => { this.read_props___digitalmenu(); }); }}></MdDishEditModal>

				<IonToast color="success" isOpen={ this.state.ionToast___copied___isOpen } message={ "Copiato negli appunti, incollalo dove vuoi" } duration={ 3000 } position="top" onDidDismiss={() => { this.setState({ ionToast___copied___isOpen: false }); }}/>

				<IonHeader>
					<IonToolbar>
						<IonButtons slot="start">
							<IonBackButton defaultHref="/dashboard" text={ this._LOCALE.translate(locale___App.ionBackButton___text) }></IonBackButton>
						</IonButtons>
					</IonToolbar>
				</IonHeader>

				<IonContent forceOverscroll={ false }>
					{(this.state.digitalmenu___props___isLoading === true) ? <>
						<br />
						<br />
						<br />
						<br />
						<br />
						<br />
						<ComSpinnerInlineComponent />
					</> : <>
						{(this.state.digitalmenu___props !== null) ? <>
							<section className="sb-digitalmenu-view---container">
									
								{(this.state.digitalmenu___props['digitalmenu_logo'] && this.state.digitalmenu___props['digitalmenu_logo'].length > 0) ? <>
									<br />
									<div className="sb-digitalmenu-view---logo">
										<img src={this.state.digitalmenu___props['digitalmenu_logo']} />
									</div>
									<br />
								</> : <></>}

								<h2 style={{textAlign:'center'}}>{ this.state.digitalmenu___props['digitalmenu_name'] }</h2>

								<br />

								<p className="input---nb-label" style={{textAlign:'center'}}>link al menu digitale</p>
								<IonSegment value={this.state.digitalmenu___url__type} onIonChange={(___e: any) => { this.handle___link___generate(___e.detail.value); }}>
									<IonSegmentButton value="link">
										<IonLabel>Link</IonLabel>
									</IonSegmentButton>
									<IonSegmentButton value="qr">
										<IonLabel>QR</IonLabel>
									</IonSegmentButton>
									<IonSegmentButton value="key">
										<IonLabel>Integra API</IonLabel>
									</IonSegmentButton>
								</IonSegment>
								<p className="input---nb-outlined" style={{textAlign:'center',fontSize:'14pt'}} onClick={() => { this.handle___link___share(); }}>{this.state.digitalmenu___url}</p>
								<ComButtonGenericComponent icon="far fa-copy" text="copia link" event___onClick={() => { this.handle___link___share(); }}/>

								<br />
								<br />
								<br />
								
								<IonCard>
									<IonList>
										<IonItem className="is-ion-item-button" button={ true } routerLink={ '/digitalmenu/edit/' + this.state.digitalmenu___id + '/dishes' }>
											<i className="fas fa-utensils"></i>
											<IonLabel><b>Modifica i Piatti</b></IonLabel>
										</IonItem>
										<IonItem className="is-ion-item-button" button={ true } routerLink={ '/digitalmenu/edit/' + this.state.digitalmenu___id + '/appearance' }>
											<i className="fas fa-paint-brush"></i>
											<IonLabel><b>Modifica Aspetto</b></IonLabel>
										</IonItem>
									</IonList>
								</IonCard>

							</section>
						</> : <>
							<Com404Component/>
						</>}
						<br />
						<br />
						<br />
					</>}
				</IonContent>

			</IonPage>
		</>;
	}

//#endregion

}

//	E X P O R T

export default withIonLifeCycle(SbDigitalMenuViewPage);